import { useMutation } from '@tanstack/react-query';
import { APIClinicBilling } from 'lib/api/firebase/apis/api-clinic-balance';
import { AssessmentType } from 'lib/documents/patient-assessment/patient-assessment';

export interface BuyAssessmentVariables {
  type: AssessmentType;
  units?: number;
  clinicId: string;
  isBulk: boolean;
}

/**
 * A mutation for purchasing assessments (bulk or pay-per-use).
 */
export function useBuyAssessmentMutation() {
  return useMutation({
    mutationFn: async (variables: BuyAssessmentVariables) => {
      if (variables.isBulk) {
        return APIClinicBilling.buyBulkAssessment({
          type: variables.type,
          units: variables.units!,
          clinicId: variables.clinicId
        });
      }

      return APIClinicBilling.buyOnDemandAssessment({
        type: variables.type,
        clinicId: variables.clinicId
      });
    },
    onError: error => {
      console.error('Purchase failed:', error);
    }
  });
}
